import React from 'react'
import { ChainId } from '@nominex/nomiswap-sdk'
import tw from 'twin.macro'
import { CogIcon, Menu as UiKitMenu, useMatchBreakpoints } from '@nominex/dex-uikit'
import { useAppKitState, AppKitButton, AppKitNetworkButton } from '@reown/appkit/react'
import { useWagmi } from 'libs/wagmi'
import { useIsAuthenticated } from 'state/profile/hooks'
// import { languageList } from 'config/localization/languages'
import GlobalSettings from './GlobalSettings'
import { NmxBreakdown } from './NmxBreakdown'
import ExtraRewardsDropdown from './ExtraRewardsDropdown'
import NmxBridgeLink from './NmxBridgeLink'
// import NomiswapV3Link from './NomiswapV3Link'
import MobileWeb3NetworkSwitch from './MobileWeb3NetworkSwitch'

const Divider = tw.div`
  w-[1px] h-[36px] bg-white/10
`

const UserMenu: React.FC = () => {
  const { account, chain, chainId } = useWagmi()
  const isAuthenticated = useIsAuthenticated()
  const { isMobile } = useMatchBreakpoints()

  return (
    <>
      {!isMobile && (
        <div className="flex flex-row gap-32 ml-8 mr-16">
          {/* <NomiswapV3Link /> */}
          {chainId !== ChainId.BSC && <NmxBridgeLink />}
        </div>
      )}
      <div />
      <div className="flex items-center gap-12">
        <NmxBreakdown />
        {isAuthenticated && account && !isMobile && chain?.id === ChainId.BSC && <ExtraRewardsDropdown />}
        {isMobile ? (
          <MobileWeb3NetworkSwitch />
        ) : (
          <>
            <Divider />
            <AppKitNetworkButton />
          </>
        )}
        <AppKitButton />
        {!isMobile && <GlobalSettings IconComponent={CogIcon} />}
      </div>
    </>
  )
}

const Menu = (props) => (
  <UiKitMenu
    userMenu={<UserMenu />}
    isDark
    // toggleTheme={toggleTheme}
    // currentLang={currentLanguage.code}
    // langs={languageList}
    // setLang={setLanguage}
    links={[]}
    activeItem=""
    {...props}
  />
)

export default Menu
